import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import PictureUpload from "components/CustomUpload/ImageUpload.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "react-datetime";
import NotifList from "granular/Notification/notifList.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Select from "@material-ui/core/Select";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { pushLoader } from "../../actions/main";

import {
  fetchVessellist,
  pushVessellist,
  pushGpsapitd,
  pushFleetrt,
  updateVessellist,
  deleteVessellist,
  pushUpdateGpsapirt,
  pushUpdateFleetrt,
  pushDeleteFleetrt,
  pushDeleteGpsapirt,
  fetchProfile
} from "../../api/vessellist";
import Vesseldt from "../../granular/MasterData/vessellistdt";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import _ from "lodash";
import { connect } from "react-redux";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";

class Vessellist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: [],
      openAdd: false,
      openEdit: false,
      urlfile: "-",
      description: "",
      file_upload: "",
      company_code: "",
      user_id: "",
      status: "add",
      id: "",
      vessel_name: "",
      vessel_captain: "",
      imo: "",
      mmsi: "",
      ship_id: "",
      flag: "",
      fuel_main_engine: "",
      proggramer: "",
      proggramer_phone_ext: "",
      proggramer_mobile_phone: "",
      password: "",
      vessel_number: "",
      grt: "",
      vessel_type: "",
      call_sign: "",
      fuel_aux_engine: "",
      speed: "",
      vessel_owner: "",
      dwt: "",
      yob: "",
      expired_date: "",
      cost_center: "",
      vessel_status: "on hire",
      ownership_status: "owner",
      vessel_category: "all",
      cot_procurement: "",
      cot_actual: "",
      loa: "",
      draft: "",
      technical_fleet: "",
      tank_capacity: "",
      programer_id: "",
      profiles: [],
      loader: null,
      title: ""
    };
  }

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    this.getDatatable();
  }

  deleteItem = (e, ship_id) => {
    deleteVessellist(e)
      .then(response => {
        if (response != null) {
          this.getDatatable();
        }
      })
      .catch(error => {
        // console.log("tidak berhasil");
        //this.props.history.push("/pages/login#logout");
      });

    //delete gpsapirt
    pushDeleteGpsapirt(ship_id)
      .then(response => {})
      .catch(error => {
        // console.log("tidak berhasil");
        //this.props.history.push("/pages/login#logout");
      });

    //delete fleetrt
    pushDeleteFleetrt(ship_id)
      .then(response => {})
      .catch(error => {
        // console.log("tidak berhasil");
        //this.props.history.push("/pages/login#logout");
      });
  };

  handleDelete = (id, ship_id) => {
    swal({
      icon: "warning",
      title: "Delete",
      text: `Are you sure to delete data vessel with id: ${id} and ship id: ${ship_id}`,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.deleteItem(id, ship_id);
      } else {
        // console.log("Batal delete");
      }
    });
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value,
      profiles: [],
      search: "",
      new: ""
    });
  };

  getDatatable = () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchVessellist()
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        this.setState({ loader: false });
        //this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
  };

  renderProfiles = e => {
    return <option value={e.id}>{e.name}</option>;
  };

  handleUpdate = (id, ship_id, searchProgrammer) => {
    // this.getProfiles();
    let datanya = _.find(this.state.datatable, { id: id });

    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchProfile()
      .then(response => {
        let profil = _.orderBy(response.data.results, "id", "asc");
        this.setState({
          profiles: profil
        });
        this.props.pushLoader(false);
        this.setState({ loader: false });
        this.setState({
          openAdd: true,
          title: "Update Vessel",
          id: datanya.id,
          vessel_name: datanya.vessel_name,
          vessel_captain: datanya.vessel_captain,
          imo: datanya.imo,
          mmsi: datanya.mmsi,
          ship_id: datanya.ship_id,
          flag: datanya.flag,
          fuel_main_engine: datanya.fuel_main_engine,
          proggramer: datanya.proggramer,
          proggramer_phone_ext: datanya.proggramer_phone_ext,
          proggramer_mobile_phone: datanya.proggramer_mobile_phone,
          // password: datanya.password,
          vessel_number: datanya.vessel_number,
          grt: datanya.grt,
          vessel_type: datanya.vessel_type,
          call_sign: datanya.call_sign,
          fuel_aux_engine: datanya.fuel_aux_engine,
          speed: datanya.speed,
          vessel_owner: datanya.vessel_owner,
          dwt: datanya.dwt,
          yob: datanya.yob,
          email: datanya.email,
          expired_date: datanya.expired_date,
          cost_center: datanya.cost_center,
          vessel_status: datanya.vessel_status,
          ownership_status: datanya.ownership_status,
          vessel_category: datanya.vessel_category,
          cot_procurement: datanya.cot_procurement,
          cot_actual: datanya.cot_actual,
          loa: datanya.loa,
          draft: datanya.draft,
          technical_fleet: datanya.technical_fleet,
          tank_capacity: datanya.tank_capacity,
          programer_id: datanya.programer_id,
          status: "update",
          errorCheck: false,
          new: _.find(profil, { id: searchProgrammer })
        });
      })
      .catch(error => {
        // console.log("tidak berhasil");
        //this.props.history.push("/pages/login#logout");
      });
  };

  handleSubmit = () => {
    if (
      this.state.vessel_name &&
      this.state.vessel_captain &&
      this.state.call_sign &&
      this.state.imo &&
      this.state.mmsi &&
      this.state.ship_id &&
      this.state.flag &&
      this.state.fuel_main_engine &&
      this.state.proggramer_phone_ext &&
      this.state.proggramer_mobile_phone &&
      this.state.vessel_number &&
      this.state.grt &&
      this.state.vessel_type &&
      this.state.fuel_aux_engine &&
      this.state.speed &&
      this.state.vessel_owner &&
      this.state.dwt &&
      this.state.yob &&
      this.state.expired_date &&
      this.state.cost_center &&
      this.state.cot_procurement &&
      this.state.cot_actual &&
      this.state.loa &&
      this.state.draft &&
      this.state.technical_fleet &&
      this.state.tank_capacity &&
      this.state.vessel_status
    ) {
      //add to vessel list
      pushVessellist(this.state)
        .then(response => {
          if (response != null) {
            this.setState({
              description: "-",
              openAdd: false
            });
            this.getDatatable();
          }
        })
        .catch(error => {
          this.props.history.push("/pages/login#logout");
        });

      // //add to gpsapits
      pushGpsapitd(this.state)
        .then(response => {})
        .catch(error => {
          //this.props.history.push("/pages/login#logout");
        });

      // //add to fleetrt
      pushFleetrt(this.state)
        .then(response => {})
        .catch(error => {
          //this.props.history.push("/pages/login#logout");
        });
    } else {
      this.setState({ errorCheck: true });
    }
  };

  handleSubmitUpdate = () => {
    if (
      this.state.vessel_name &&
      this.state.vessel_captain &&
      this.state.call_sign &&
      this.state.imo &&
      this.state.mmsi &&
      this.state.ship_id &&
      this.state.flag &&
      this.state.fuel_main_engine &&
      this.state.proggramer_phone_ext &&
      this.state.proggramer_mobile_phone &&
      this.state.vessel_number &&
      this.state.grt &&
      this.state.vessel_type &&
      this.state.fuel_aux_engine &&
      this.state.speed &&
      this.state.vessel_owner &&
      this.state.dwt &&
      this.state.yob &&
      this.state.expired_date &&
      this.state.cost_center &&
      this.state.cot_procurement &&
      this.state.cot_actual &&
      this.state.loa &&
      this.state.draft &&
      this.state.technical_fleet &&
      this.state.tank_capacity &&
      this.state.vessel_status
    ) {
      updateVessellist(this.state)
        .then(response => {
          if (response != null) {
            this.setState({
              description: "-",
              openAdd: false
            });
            //update gpsapirt
            pushUpdateGpsapirt(this.state)
              .then(response => {})
              .catch(error => {
                //this.props.history.push("/pages/login#logout");
              });

            // update fleetrtptmnnew
            pushUpdateFleetrt(this.state)
              .then(response => {})
              .catch(error => {
                //this.props.history.push("/pages/login#logout");
              });
            this.getDatatable();
          }
        })
        .catch(error => {
          this.props.history.push("/pages/login#logout");
        });
    } else {
      this.setState({ errorCheck: true });
    }
  };

  handleFileUpload = event => {
    this.setState({ file_upload: event.target.files[0] });
    //console.log(event.target.files[0].name);

    const ext = event.target.files[0].name.split(".");

    // proccessUpload(event.target.files[0], ext[1])
    //   .then(response => {
    //     this.setState({ urlfile: response.data.url })
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  };

  handleChangeText = (keys, e) => {
    this.setState({ [keys]: e.target.value });
  };

  handleAdd = () => {
    let ship_idgen = "X" + Math.floor(100000 + Math.random() * 900000);
    this.props.pushLoader(true);
    this.setState({ loader: true });
    this.setState({
      openAdd: true,
      title: "Add Vessel",
      urlfile: "-",
      description: "",
      file_upload: "",
      company_code: "",
      user_id: "",
      status: "add",
      id: "",
      vessel_name: "",
      vessel_captain: "",
      imo: "",
      mmsi: "",
      ship_id: ship_idgen,
      flag: "",
      fuel_main_engine: "",
      proggramer: "",
      proggramer_phone_ext: "",
      proggramer_mobile_phone: "",
      password: "",
      vessel_number: "",
      grt: "",
      vessel_type: "",
      call_sign: "",
      fuel_aux_engine: "",
      speed: "",
      vessel_owner: "",
      dwt: "",
      yob: "",
      expired_date: "",
      email: "",
      cost_center: "",
      vessel_status: "on hire",
      ownership_status: "owner",
      cot_procurement: "",
      cot_actual: "",
      loa: "",
      draft: "",
      technical_fleet: "",
      tank_capacity: "",
      programer_id: "12",
      errorCheck: false,
      search: ""
    });
    fetchProfile()
      .then(response => {
        this.setState({
          profiles: _.orderBy(response.data.results, "id", "asc")
        });
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        // console.log("tidak berhasil");
        //this.props.history.push("/pages/login#logout");
      });
  };

  renderAction = () => {
    if (this.state.status == "add") {
      return (
        <Button onClick={() => this.handleSubmit()} color="success" round>
          Add
        </Button>
      );
    } else {
      return (
        <Button onClick={() => this.handleSubmitUpdate()} color="success" round>
          Update
        </Button>
      );
    }
  };

  handleChangeProfile = (e, index) => {
    this.setState({
      programer_id: e.target.value,
      proggramer: e.target.selectedOptions[0].text
    });
  };

  handleChangeVesselStatus = e => {
    this.setState({ vessel_status: e.target.value });
  };

  handleChangeOwnershipStatus = e => {
    this.setState({ ownership_status: e.target.value });
  };

  handleChangeVesselCategory = e => {
    this.setState({ vessel_category: e.target.value });
  };

  handleError = e => {
    if (e === "" || e === null) return true;
    return false;
  };
  handleHelperText = (e, check) => {
    if (this.state.errorCheck) if (check(e)) return "This field is required";
  };

  renderAdd = e => {
    if (localStorage.getItem("userlevel") != 3) {
      return (
        <Button color="success" round onClick={() => this.handleAdd()}>
          Add Data
        </Button>
      );
    } else {
      return <div />;
    }
  };

  render() {
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              {this.renderAdd()}
            </CardHeader>
            <Vesseldt
              datatable={this.state.datatable}
              handleDelete={this.handleDelete}
              handleUpdate={this.handleUpdate}
              loader={this.state.loader}
            />
          </Card>
          <Dialog
            fullScreen
            open={this.state.openAdd}
            onClose={() => this.handleClose("openAdd", false)}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">{this.state.title}</DialogTitle>
            <DialogContent>
              <GridContainer style={{ padding: 40 }}>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="vessel name"
                    id="vessel_name"
                    helpText={this.handleHelperText(
                      this.state.vessel_name,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.vessel_name)
                        : false,
                      value: this.state.vessel_name,
                      //onChange: e => { this.setState({description: e.target.value}) }
                      onChange: e => this.handleChangeText("vessel_name", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="vessel captain"
                    id="vessel_captain"
                    helpText={this.handleHelperText(
                      this.state.vessel_captain,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.vessel_captain)
                        : false,
                      value: this.state.vessel_captain,
                      //onChange: e => { this.setState({description: e.target.value}) }
                      onChange: e => this.handleChangeText("vessel_captain", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <InputLabel htmlFor="name-native-disabled">
                    programmer
                  </InputLabel>
                  <Autocomplete
                    value={this.state.new}
                    onChange={(event, newValue) => {
                      this.setState({ new: newValue });
                    }}
                    inputValue={this.state.search}
                    onInputChange={(event, newInputValue) => {
                      let valuenya = newInputValue.split(") ");
                      this.setState({
                        search: newInputValue,
                        programer_id: valuenya[0].slice(1),
                        proggramer: valuenya[1]
                      });
                    }}
                    id="programmer-search"
                    options={this.state.profiles}
                    getOptionLabel={option =>
                      "(" + option.id + ") " + option.name
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Search"
                        //variant="filled"
                        style={{ width: "100%", paddingBottom: 1 }}
                      />
                    )}
                  />
                  {/* <Select
                    native
                    value={this.state.programer_id}
                    onChange={this.handleChangeProfile}
                    inputProps={{
                      name: "age",
                      id: "age-native-simple"
                    }}
                  >
                    {this.state.profiles.map(this.renderProfiles)}
                  </Select> */}
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="call sign"
                    id="call_sign"
                    helpText={this.handleHelperText(
                      this.state.call_sign,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.call_sign)
                        : false,
                      value: this.state.call_sign,
                      onChange: e => this.handleChangeText("call_sign", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="imo"
                    id="imo"
                    helpText={this.handleHelperText(
                      this.state.imo,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.imo)
                        : false,
                      value: this.state.imo,
                      onChange: e => this.handleChangeText("imo", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="mmsi"
                    id="mmsi"
                    helpText={this.handleHelperText(
                      this.state.mmsi,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.mmsi)
                        : false,
                      value: this.state.mmsi,
                      onChange: e => this.handleChangeText("mmsi", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="ship id"
                    id="ship_id"
                    helpText={this.handleHelperText(
                      this.state.ship_id,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.ship_id)
                        : false,
                      value: this.state.ship_id,
                      onChange: e => this.handleChangeText("ship_id", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="flag"
                    id="flag"
                    helpText={this.handleHelperText(
                      this.state.flag,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.flag)
                        : false,
                      value: this.state.flag,
                      onChange: e => this.handleChangeText("flag", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="fuel main engine"
                    id="fuel_main_engine"
                    helpText={this.handleHelperText(
                      this.state.fuel_main_engine,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.fuel_main_engine)
                        : false,
                      value: this.state.fuel_main_engine,
                      onChange: e =>
                        this.handleChangeText("fuel_main_engine", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>

                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="proggramer phone ext"
                    id="proggramer_phone_ext"
                    helpText={this.handleHelperText(
                      this.state.proggramer_phone_ext,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.proggramer_phone_ext)
                        : false,
                      value: this.state.proggramer_phone_ext,
                      onChange: e =>
                        this.handleChangeText("proggramer_phone_ext", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="proggramer mobile phone"
                    id="proggramer_mobile_phone"
                    helpText={this.handleHelperText(
                      this.state.proggramer_mobile_phone,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.proggramer_mobile_phone)
                        : false,
                      value: this.state.proggramer_mobile_phone,
                      onChange: e =>
                        this.handleChangeText("proggramer_mobile_phone", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                {/* <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="email"
                    id="email"
                    helpText={this.handleHelperText(
                      this.state.email,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.email)
                        : false,
                      value: this.state.email,
                      onChange: e => this.handleChangeText("email", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <!--<GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="password"
                    id="password"
                    helpText={this.handleHelperText(
                      this.state.password,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.password)
                        : false,
                      value: this.state.password,
                      onChange: e => this.handleChangeText("password", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>--> */}
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="vessel number"
                    id="vessel_number"
                    helpText={this.handleHelperText(
                      this.state.vessel_number,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.vessel_number)
                        : false,
                      value: this.state.vessel_number,
                      onChange: e => this.handleChangeText("vessel_number", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="grt"
                    id="grt"
                    helpText={this.handleHelperText(
                      this.state.grt,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.grt)
                        : false,
                      value: this.state.grt,
                      onChange: e => this.handleChangeText("grt", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="vessel type"
                    id="vessel_type"
                    helpText={this.handleHelperText(
                      this.state.vessel_type,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.vessel_type)
                        : false,
                      value: this.state.vessel_type,
                      onChange: e => this.handleChangeText("vessel_type", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>

                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="fuel aux engine"
                    id="fuel_aux_engine"
                    helpText={this.handleHelperText(
                      this.state.fuel_aux_engine,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.fuel_aux_engine)
                        : false,
                      value: this.state.fuel_aux_engine,
                      onChange: e => this.handleChangeText("fuel_aux_engine", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="speed"
                    id="speed"
                    helpText={this.handleHelperText(
                      this.state.speed,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.speed)
                        : false,
                      value: this.state.speed,
                      onChange: e => this.handleChangeText("speed", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="vessel owner"
                    id="vessel_owner"
                    helpText={this.handleHelperText(
                      this.state.vessel_owner,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.vessel_owner)
                        : false,
                      value: this.state.vessel_owner,
                      onChange: e => this.handleChangeText("vessel_owner", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="dwt"
                    id="dwt"
                    helpText={this.handleHelperText(
                      this.state.dwt,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.dwt)
                        : false,
                      value: this.state.dwt,
                      onChange: e => this.handleChangeText("dwt", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="yob"
                    id="yob"
                    helpText={this.handleHelperText(
                      this.state.yob,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.yob)
                        : false,
                      value: this.state.yob,
                      onChange: e => this.handleChangeText("yob", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="expired date"
                    id="expired_date"
                    helpText={this.handleHelperText(
                      this.state.expired_date,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.expired_date)
                        : false,
                      value: this.state.expired_date,
                      onChange: e => this.handleChangeText("expired_date", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="cost center"
                    id="cost_center"
                    helpText={this.handleHelperText(
                      this.state.cost_center,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.cost_center)
                        : false,
                      value: this.state.cost_center,
                      onChange: e => this.handleChangeText("cost_center", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <InputLabel htmlFor="name-native-disabled">
                    ownership status
                  </InputLabel>
                  <Select
                    native
                    value={this.state.ownership_status}
                    onChange={this.handleChangeOwnershipStatus}
                    inputProps={{
                      name: "ownership_status",
                      id: "ownership_status"
                    }}
                  >
                    <option value="owner">owner</option>
                    <option value="contract">contract</option>
                  </Select>
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <InputLabel htmlFor="name-native-disabled">
                    vessel status
                  </InputLabel>
                  <Select
                    native
                    value={this.state.vessel_status}
                    onChange={this.handleChangeVesselStatus}
                    inputProps={{
                      name: "vessel_status",
                      id: "vessel_status"
                    }}
                  >
                    <option value="on hire">on hire</option>
                    <option value="off hire">off hire</option>
                    <option value="owned">owned</option>
                  </Select>
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <InputLabel htmlFor="name-native-disabled">
                    vessel category
                  </InputLabel>
                  <Select
                    native
                    value={this.state.vessel_category}
                    onChange={this.handleChangeVesselCategory}
                    inputProps={{
                      name: "vessel_category",
                      id: "vessel_category"
                    }}
                  >
                    <option value="all">all</option>
                    <option value="small vessel">small vessel</option>
                    <option value="large vessel">large vessel</option>
                  </Select>
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="cot procurement"
                    id="cot_procurement"
                    helpText={this.handleHelperText(
                      this.state.cot_procurement,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.cot_procurement)
                        : false,
                      value: this.state.cot_procurement,
                      onChange: e => this.handleChangeText("cot_procurement", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="cot actual"
                    id="cot_actual"
                    helpText={this.handleHelperText(
                      this.state.cot_actual,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.cot_actual)
                        : false,
                      value: this.state.cot_actual,
                      onChange: e => this.handleChangeText("cot_actual", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="loa"
                    id="loa"
                    helpText={this.handleHelperText(
                      this.state.loa,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.loa)
                        : false,
                      value: this.state.loa,
                      onChange: e => this.handleChangeText("loa", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="draft"
                    id="draft"
                    helpText={this.handleHelperText(
                      this.state.draft,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.draft)
                        : false,
                      value: this.state.draft,
                      onChange: e => this.handleChangeText("draft", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="technical fleet"
                    id="technical_fleet"
                    helpText={this.handleHelperText(
                      this.state.technical_fleet,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.technical_fleet)
                        : false,
                      value: this.state.technical_fleet,
                      onChange: e => this.handleChangeText("technical_fleet", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="tank capacity"
                    id="tank_capacity"
                    helpText={this.handleHelperText(
                      this.state.tank_capacity,
                      this.handleError
                    )}
                    inputProps={{
                      error: this.state.errorCheck
                        ? this.handleError(this.state.tank_capacity)
                        : false,
                      value: this.state.tank_capacity,
                      onChange: e => this.handleChangeText("tank_capacity", e)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
              </GridContainer>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.handleClose("openAdd", false)}
                color="danger"
                round
              >
                Cancel
              </Button>
              {this.renderAction()}
            </DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default withRouter(
  connect(
    mapStateToProps,
    { pushLoader }
  )(Vessellist)
);
